// *******************************************************************************
// B2B Cart form validation
// *******************************************************************************

const b2bLoginForm = document.getElementById('cart-b2b');
if (b2bLoginForm) {
  document.addEventListener('DOMContentLoaded', () => {
    if (b2bLoginForm) {
      // B2B Cart - add/remove items
      const b2bFinalPriceEl = document.querySelector('.b2b-cart__final-price-price .title--h2');
      const b2bFinalPriceWithoutTaxEl = document.querySelector('.b2b-cart__taxes .price-without-tax');
      const b2bFinalTaxEl = document.querySelector('.b2b-cart__taxes .price-tax');
      const b2bSubmitEl = document.querySelector('.b2b-cart__submit');
      const userRabat = document.querySelector('[data-userrabat]');

      const b2bSetPrices = () => {
        let b2bTotalPrice = 0;
        document.querySelectorAll('.b2b-cart__product').forEach((product) => {
          const b2bProductPrice = product.querySelector('.b2b-cart__product-amount-price').dataset.price;
          const b2bProductSlashedPrice = product.querySelector('.b2b-cart__product-amount-price').dataset.slashedprice;
          const quantity = product.querySelector('.amount');
          const b2bProductPriceSum = parseFloat(b2bProductPrice) * parseFloat(quantity.innerText);
          if (b2bProductSlashedPrice && b2bProductPrice !== b2bProductSlashedPrice) {
            // eslint-disable-next-line no-param-reassign
            product.querySelector('.b2b-cart__product-price .title--h3 s').innerHTML = getPriceInEuro(
              b2bProductSlashedPrice * quantity.innerText,
            );
          }
          b2bTotalPrice += parseFloat(b2bProductPrice) * parseFloat(quantity.innerText);
          // eslint-disable-next-line no-param-reassign
          product.querySelector('.b2b-cart__product-price .title--h3 .b2b-cart__product-final-price').innerHTML =
            getPriceInEuro(b2bProductPriceSum);
        });
        setPriceInEuro(b2bFinalPriceWithoutTaxEl, b2bTotalPrice);
        if (userRabat) {
          const rabatAmount = (b2bTotalPrice * userRabat.dataset.userrabat) / 100;
          b2bTotalPrice -= rabatAmount;
          setPriceInEuro(document.querySelector('.user-discount'), rabatAmount);
        }
        setPriceInEuro(b2bFinalPriceEl, b2bTotalPrice);
      };

      const addRemoveB2BItem = (element, increment, remove = false) => {
        const parentElem = element.closest('.b2b-cart__product');
        const productData = parentElem.querySelector('.b2b-cart__product-amount-price');
        const amount = parentElem.querySelector('.amount');
        const currentAmount = parseInt(amount.innerText, 10);
        const b2bCart = JSON.parse(getCookie('b2b-cart'));
        const categoryId = parseInt(productData.dataset.categoryid, 10);

        if (!increment && currentAmount === 1) {
          return;
        }

        amount.innerText = increment ? currentAmount + 1 : currentAmount - 1;

        const product = {
          product_id: productData.dataset.parentid,
          variation_id: productData.dataset.variationid,
        };

        b2bCart.forEach((item, index) => {
          if (item.product_id === product.product_id && item.variation_id === product.variation_id) {
            if (remove) {
              b2bCart.splice(index, 1);
              parentElem.remove();

              const itemFromSameCategory = document.querySelector(`.b2b-cart__product-amount-price[data-categoryid="${categoryId}"]`);
              if (!itemFromSameCategory) {
                const categoryDiscount = document.querySelector(`.category-discount[data-category="${categoryId}"]`);
                if (categoryDiscount) {
                  categoryDiscount.parentElement.remove();

                  if (document.querySelectorAll('.category-discount').length < 2) {
                    b2bFinalTaxEl.parentElement.remove();
                  }
                }
              }
            } else {
              b2bCart[index].quantity = parseFloat(amount.innerText);
            }
          }
        });

        if (b2bCart.length === 0) {
          b2bSubmitEl.remove();
          ['.b2b-cart__textarea', '.b2b-cart__checkbox', '.b2b-cart__footer > .margin--20', '.b2b-cart__footer > .margin--34'].forEach(
            (selector) => {
              document.querySelector(selector).remove();
            },
          );
        }

        setCookie('b2b-cart', JSON.stringify(b2bCart));
        b2bSetPrices();
      };

      attachEvent('.b2b-cart__products .more', 'click', (ev) => {
        addRemoveB2BItem(ev.target, true);
      });
      attachEvent('.b2b-cart__products .less', 'click', (ev) => {
        addRemoveB2BItem(ev.target, false);
      });
      attachEvent('.b2b-cart__product-delete', 'click', (ev) => {
        addRemoveB2BItem(ev.target, true, true);
      });
    }
  });
}

// Form Validation
const b2bCartForm = document.querySelector('.b2b-cart');
if (b2bCartForm) {
  document.addEventListener('DOMContentLoaded', () => {
    const b2bCartFormEle = document.getElementById('cart-b2b');
    const b2bFormErrorMessage = b2bCartForm.querySelector('.form-error-message');

    const axiosMakeOrderB2B = (data, formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formData.b2b_form_action }).then((token) => {
          const formDataInput = new FormData();
          formDataInput.append('action', formData.b2b_form_action);
          formDataInput.append('nonce', formData.b2b_form_nonce);
          formDataInput.append('inputs', data);
          formDataInput.append('form_inputs', JSON.stringify(formData));
          formDataInput.append('token', token);
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {
                deleteCookie('b2b-cart');
                window.location.href = response.data.data.redirect;
              }
            })
            .catch((err) => {
              console.error(err);
              b2bFormErrorMessage.innerHTML = err.response.data.data.message;
              b2bFormErrorMessage.classList.add('is-validation-failed');
              toggleLoader(false);
            });
        });
      });
    };

    if (b2bCartFormEle) {
      const fv = FormValidation.formValidation(b2bCartFormEle, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {},
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.mod-input , .checkbox'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      })
        .on('core.element.validated', (e) => {
          // e.element presents the field element
          // e.valid indicates the field is valid or not

          // Get the field value
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input , .checkbox');
          FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
        })
        .on('core.form.valid', () => {
          b2bFormErrorMessage.classList.remove('is-validation-failed');
          const formData = {};
          b2bCartForm.querySelectorAll('input, textarea').forEach((input) => {
            if (input.type === 'checkbox') {
              formData[input.name] = input.checked;
            } else {
              formData[input.name] = input.value.trim();
            }
          });
          toggleLoader(true);
          axiosMakeOrderB2B(getCookie('b2b-cart'), formData);
        });
    }
  });
}
